import { gql } from "@apollo/client";

export const REFRESH_TOKEN = gql`
  mutation RefreshToken {
    refreshToken {
      success
      error
    }
  }
`;

export const GOOGLE_AUTH = gql`
  mutation GoogleAuth($idToken: String!) {
    googleAuth(idToken: $idToken) {
      success
      error
      userId
      email
      phone
    }
  }
`;

export const EXCHANGE_TOKEN = gql`
  mutation ExchangeToken($token: String!) {
    exchangeToken(token: $token) {
      success
      error
      userId
      email
      phone
    }
  }
`;
